export default __webpack_public_path__ + "static/media/Nunito-BoldItalic.4dcb6f25.woff2";